import React, { useEffect } from "react";
import { gsap } from "gsap";
import LinkCard from "../components/catalyst/LinkCard";

const EduHub = () => {
  const styles = {
    blackbg: {
      backgroundColor: "#121212",
    },
    blueText: {
      color: "#037ef3",
    },
    hidden: {
      visibility: "hidden",
    },
  };

  useEffect(() => {
    gsap.set(".link-card", {
      autoAlpha: 0,
      scale: 0.6,
      y: 40,
    });

    gsap.from(".animated-title", {
      ease: "expo.inOut",
      autoAlpha: 0,
      y: 80,
      duration: 2,
      stagger: 0.1,
    });

    gsap.to(".link-card", {
      y: 0,
      ease: "expo.inOut",
      scale: 1,
      autoAlpha: 1,
      duration: 1.5,
      delay: 0.6,
      stagger: 0.1,
    });
  }, []);

  return (
    <div className="w-full min-h-screen text-white pb-8" style={styles.blackbg}>
      <div className="w-full flex flex-col justify-center items-center pt-10">
        <div className="mt-4 text-xl animated-title" style={{ ...styles.hidden, ...styles.blueText }}>
          AIESEC in SLIIT
        </div>
        <div className="mt-4 text-5xl animated-title" style={{ ...styles.hidden }}>
          Knowledge Hub
        </div>

        <div className="my-2 text-3xl font-thin countdown" style={{ fontFamily: "monospace", color: "#f00" }}></div>
      </div>

      <div className="w-full max-w-md m-auto mt-4 mb-10 px-4">
        <hr className="text-blue animated-title" />
        <div className="mt-4 text-2xl animated-title text-center" style={{ ...styles.hidden }}>
          Front-Office
        </div>

        <div className="text-2xl animated-title opacity-75 text-center" style={{ ...styles.hidden }}>
          iCX
        </div>

        <LinkCard title="Incoming Global Volunteer" color="#F85A40" newTab={true} link="https://hub.aiesec.lk/igv.html" />
        <LinkCard title="Incoming Global Talent" color="#F48924" newTab={true} link="https://hub.aiesec.lk/igt.html" />
        <LinkCard title="Incoming Global Teacher" color="#0CB9C1" newTab={true} link="https://hub.aiesec.lk/igtae.html" />

        <div className="mt-8 text-2xl animated-title opacity-75 text-center" style={{ ...styles.hidden }}>
          oGX
        </div>

        <LinkCard title="Outgoing Global Volunteer" color="#F85A40" newTab={true} link="https://hub.aiesec.lk/ogv.html" />
        <LinkCard title="Outgoing Global Talent" color="#F48924" newTab={true} link="https://hub.aiesec.lk/ogt.html" />
        <LinkCard title="Outgoing Global Teacher" color="#0CB9C1" newTab={true} link="https://hub.aiesec.lk/ogtae.html" />

        <hr className="mt-12 text-red animated-title" />
        <div className="mt-4 text-2xl animated-title text-center" style={{ ...styles.hidden }}>
          Back-Office
        </div>

        <LinkCard title="People Management" color="#037Ef3" newTab={true} link="https://hub.aiesec.lk/pm.html" />
        <LinkCard title="B2B &amp; BCXP" color="#00C16E" newTab={true} link="https://hub.aiesec.lk/b2b.html" />
        <LinkCard title="Digital B2C" color="#F48924" newTab={true} link="https://hub.aiesec.lk/b2c.html" />
        <LinkCard title="Finance &amp; Legal" color="#FFC845" newTab={true} link="https://hub.aiesec.lk/finance.html" />
        <LinkCard title="Business Development" color="#0CB9C1" newTab={true} link="https://hub.aiesec.lk/bd.html" />
        <LinkCard title="Public Relations" color="#F85A40" newTab={true} link="https://hub.aiesec.lk/pr.html" />
      </div>
    </div>
  );
};

export default EduHub;
